
import { Component, Prop, Vue } from "vue-property-decorator";
import QaVue from "../qa/Qa.vue";
import { RouterHelper } from "@/router/routerHelper";

@Component({
  components: {
    qa: QaVue,
  },
})
export default class LiteBeeWingFbQaVue extends Vue {
  prodName: string = "LiteBee Wing FB";
  prodCode: string = "liteBeeWingFb";
  tabList: Array<any> = [];

  linkData: Array<any> = [
    { name: "首页", link: "/" },
    { name: this.prodName, link: "/product/liteBeeWingFb" },
    { name: "常见问题", link: "#" },
  ];

  mounted() {
    RouterHelper.getProdRouterConfig(this.prodCode, (data: Array<any>) => {
      this.tabList = data;
    });
  }
}
